import script from "./LicenseSet.vue?vue&type=script&setup=true&lang=js"
export * from "./LicenseSet.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__